/**
 * Aviso de "sin patios asignados".
 *
 * Es la cara visible del fallo CERRADO del issue #497: antes, un usuario con rol
 * restringido y la lista de patios vacía apagaba el recorte y veía el catálogo
 * completo. Ahora no ve nada — y sin este cartel "nada" se leería como un bug o
 * como que no hay datos, cuando lo que falta es la asignación.
 */
export default function NoAssignedYardsNotice({
  isDarkMode,
  what = "información",
}: {
  isDarkMode: boolean;
  /** Qué es lo que no se puede mostrar, para redactar la frase. */
  what?: string;
}) {
  return (
    <div
      role="status"
      className={`rounded-2xl border px-5 py-6 text-center ${
        isDarkMode
          ? "border-amber-500/30 bg-amber-500/10"
          : "border-amber-300 bg-amber-50"
      }`}
    >
      <i className="ri-error-warning-line text-2xl text-amber-500" />
      <p
        className={`mt-2 text-sm font-semibold ${
          isDarkMode ? "text-amber-300" : "text-amber-700"
        }`}
      >
        No tienes patios asignados
      </p>
      <p
        className={`mt-1 text-xs ${
          isDarkMode ? "text-amber-200/70" : "text-amber-700/80"
        }`}
      >
        Por eso no se muestra {what}. Pedile a un administrador que te asigne al
        menos un patio desde Patios &gt; Personal.
      </p>
    </div>
  );
}
